import { render, staticRenderFns } from "./talentPolicy.vue?vue&type=template&id=4997ecd2&scoped=true&"
import script from "./talentPolicy.vue?vue&type=script&lang=js&"
export * from "./talentPolicy.vue?vue&type=script&lang=js&"
import style0 from "./talentPolicy.vue?vue&type=style&index=0&id=4997ecd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4997ecd2",
  null
  
)

export default component.exports